<template>
  <div>
    <ul class="list list--striped">
      <li class="list__item list__title">
        <span>{{ $t('emailsList.emailColumn') }}</span>
        <span>{{ $t('emailsList.dateColumn') }}</span>
      </li>
      <li class="list__item" v-for="email in emails" :key="email.id">
        <span>{{ email.subscription_email }}</span>
        <span>{{ parsedDate(email.created_at) }}</span>
      </li>
    </ul>
    <div class="pagination-cont" v-show="numberOfPages > 1">
      <div class="pagination">
        <a class="pagination__item"
          @click="getEmailsOfPage(currentPage - 1)"
          v-show="currentPage !== 1">«</a>

        <a class="pagination__item"
          @click="getEmailsOfPage(page)"
          :class="{ 'active' : currentPage == page }"
          v-for="page in numberOfPages"
          :key="page">
          {{ page }}
        </a>

        <a class="pagination__item"
          @click="getEmailsOfPage(currentPage + 1)"
          v-show="currentPage !== numberOfPages">»</a>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import dateHelper from '../../../services/date';

  export default {
    computed: mapGetters({
      emails: 'emails/emailsList',
      numberOfPages: 'emails/numberOfPages',
      currentPage: 'emails/currentPage',
    }),
    methods: {
      parsedDate(date) {
        return dateHelper.formatedDate(date, this.$t('date.dateAndTime'));
      },
      ...mapActions({
        getEmailsOfPage: 'emails/getEmailsOfPage',
      }),
    },
  };
</script>



// WEBPACK FOOTER //
// src/screens/Emails/components/List.vue